import { Store } from '../stores/student-dashboard';
import { Store as ParentStore} from '../stores/parent-dashboard';

import { getFreemiumAbTestAssignedSegment, isIOS, isMobileDevice, isMobileOrIpad,
  getDRSLiveClassesTrialAbTestAssignedSegment, getCookie, fetchDiffInMinsBetweenTimestamps,
  getUserCountryCode, fetchHighestUserGrade, isSchoolHoursAvailable,
  isTabletDevice, isOldPlanTierAssigned, isUSOrCACountry, isAnyStudentClassroomLinked,
  hasFullAccessToProductType, getCurrentOfferings,
  OfferingType, showNewUnlockBannerOnApp, getDeviceType, getUserPreferredLanguage,
  isExpiredUser, getSubscriptionAccessStatus} from './web-helper';
import { ActivityGamesClasses, multiplayer_classes, dateForActivityGamesChanges } from '../constant-data/multiplayer-data';
import { getABTestValue, getTeacherABTestValue, getAllAbTests } from './ab-tests';
import { freemium_supported_grades } from '../constant-data/freemium-interface';
import { FREEMIUM_NO_BLOCKER_TIME_IN_MINUTE, PRE_K_GRADE, EXPIRED } from '../constant-data/constants';
import { FetchPermanentNudgeCtaConfig } from '../services/student-api';

export const hasGamification = () => {
  return true;
}

export const hasC1Enabled = () => {
  const { settings } = Store.getState();
  if(settings) {
    return settings.is_classroom_student ? true: settings.c1_enabled;
  }
}

export const isPaymentElementEnabled = (productSettings) => {

  if (productSettings?.stripePaymentMethods && productSettings.stripePaymentMethods.length > 0) {
    return true
  }

  const parentEnabled = () => {
    return getABTestValue('Parent', 'StripePaymentFormType') === 'variant';
  }

  // if student is linked to parent and lands on purchase page use teacher ab test
  const parentEnabledByTeacher = () => {
    const {abTests} = ParentStore.getState();
    if (abTests && abTests.teacher) {
      return abTests.teacher["Teacher::StripePaymentFormType"] == 'variant'
    }
  }

  const testEnabled = () => {
    let stripeElement = window.localStorage.getItem('stripeElement');
    return stripeElement && stripeElement === 'variant';
  }

  const teacherEnabled = () => {
    const {abTests} =  Store.getState();
    if(abTests && abTests.teacher) {
      return abTests.teacher["Teacher::StripePaymentFormType"] === 'variant';
    }
  }

  return parentEnabled() || teacherEnabled() || parentEnabledByTeacher() || testEnabled();
}

// checking whether gamification dashboard to be shown or not for b2b
export const gamificationDashboardForBtb = (params) => {
  const { student } = params ? params : Store.getState();
  if(student) {
    return student.has_splashverse_enabled;
  }
}

// Method to check the cookies of web-wiew exist or not
export const isWebView = () => {
  const cookiesList = document.cookie.split(';');
  if(sessionStorage.getItem('webview')){
    return true;
  }
  if(cookiesList.length > 0) {
    let index = cookiesList.findIndex(x => x.includes('web_view'));
    if(index !== -1) {
      return true;
    } else {
      return false;
    }
  }
  return false;
}

/**
 * @param {*} params Ab test details fetched in profile api
 */
export const hasC4Enabled = (params) => {
  const { student, abTests } = params ? params : Store.getState();
  // this is done to support app web-view where we are directly opening play with friends
  if(isWebView()) {
    return true;
  }
  if(abTests && abTests.teacher) {
    const abtestSegment = abTests.teacher["Teacher::GamificationC4Teacher"]
    if (!abtestSegment || abtestSegment == 'Gamification_C4_Off') return false
    else return multiplayer_classes.includes(student.classroom_grade) && !(isMobileOrIpad() || isIOS());
  }
}

// Method to check whether Behaviour Quest Enabled or not
export const hasBQEnabled = () => {
  const behavioral_quest_enabled = getABTestValue("Parent","BQ") === "bq_on" ? true : false
   const { current_course } = Store.getState();
  if(current_course && current_course.grade_code) {
    return behavioral_quest_enabled && current_course.grade_code !== 'pk';
  }
  return false;
}

export const hasAccessToOneVsOne = () => {
  const {abTests} =  Store.getState();
  if(abTests && abTests.teacher) {
    const abTestSegment = abTests.teacher["Teacher::GamificationC4OneVsOneTeacher"]
    return ['C4_1v1_New_Variant', 'C4_1v1_Old_Variant'].includes(abTestSegment);
  }
  return false;
}

export const hasAccessToFreemium = (params) => {
  const { student, abTests } = params ? params : Store.getState();
  const parentFreemiumAbTestAssigned = getFreemiumAbTestAssigned();
  const teacherFreemiumAbTestAssigned = abTests && abTests.teacher && abTests.teacher['Teacher::Freemium_Topics_Out'];

  const parentEligibleForFreemium = !student.is_classroom_linked && (parentFreemiumAbTestAssigned && parentFreemiumAbTestAssigned !==  "Topics_Out_Off") ;
  const teacherEligibleForFreemium = student.is_classroom_linked && (teacherFreemiumAbTestAssigned && teacherFreemiumAbTestAssigned !== "Topics_Out_Off");

  return !isMobileDevice() && (parentEligibleForFreemium || teacherEligibleForFreemium);

}

export const getFreemiumAbTestAssigned = () =>{
  const {parentFreemiumAbTestAssignedSegment, teacherFreemiumAbTestAssignedSegment} = getFreemiumAbTestAssignedSegment() || {}

  const { settings } = Store.getState();
  if(settings.is_classroom_student) {
    return teacherFreemiumAbTestAssignedSegment;
  }
  else{
    return parentFreemiumAbTestAssignedSegment;
  }
}

export const isFreemiumDRSAssigned = () => {
  const segmentName = getFreemiumAbTestAssigned();
  if((segmentName === "Topics_Out_On_DRS" || segmentName === "DRSWithLiveClasses") && !isMobileDevice())
    return true;
  else
    return false;
}

export const canSeeSplashArenaTabOnFreemium = () => { //if any subject falls in eligibilty
  const { student, courses } = Store.getState();
  if (student.is_classroom_linked) {
    return freemium_supported_grades.includes(student.classroom_grade);
  }
  else {
    for (const item of courses) {
      if (freemium_supported_grades.includes(item.grade_code)) {
        return true;
      }
    }
    return false;
  }
}

// to check eligible grades for activity games i.e pk, k and 1
const parentGradeEligibleActivityGames = (courses) => {
  if (courses) {
    for (const item of courses) {
      if (ActivityGamesClasses.includes(item.grade_code)) {
        return true;
      }
    }
  }
  return false;
}

export const hasAccessToActivityGames = (params) => {
  if (isWebView())
    return false;
  const { courses, current_user } = params ? params : Store.getState();
  const userCreatedDate = new Date(current_user?.created_at);
  const effectiveActivityGamesDate = new Date(dateForActivityGamesChanges);
  const isActivityGames = userCreatedDate > effectiveActivityGamesDate;
  return isActivityGames && parentGradeEligibleActivityGames(courses);
}

// for old gamification user return true
export const toShowLiveClassTabOnGamification = () => {

  /// Not displaying live class in school hours
  if(isSchoolHoursAvailable()){
    return false;
  }

  // Available for US and Canada user only
  if(isWebView()){
    return false
  }
  let userCountry = getUserCountryCode() || "IN"
  // show t2 tab for all user on staging
  if(location.href.indexOf('staging-1') != -1){
    userCountry = 'US';
  }
  if(userCountry === 'US' || userCountry === 'CA'){
    return true;
  }
  else{
    return false;
  }
}

export const getDRSLiveClassAbTestAssigned = () =>{
  const {parentDRSLiveClassesTrialAbTestAssignedSegment, teacherDRSLiveClassesTrialAbTestAssignedSegment} = getDRSLiveClassesTrialAbTestAssignedSegment();
  const { settings } = Store.getState();
  if(settings.is_classroom_student) {
    return teacherDRSLiveClassesTrialAbTestAssignedSegment;
  }
  else{
    return parentDRSLiveClassesTrialAbTestAssignedSegment;
  }
}

/// Checks whether Flutter DRS AB test assigned or not
export const hasAccessToFlutterDRS = () =>{
  const { abTests } =  Store.getState();
  const parentDRSFlutterABTest = getABTestValue('Parent','DRSFlutter') || "";
  const teacherDRSFlutterABTest = abTests && abTests?.teacher && abTests.teacher['Teacher::DRSFlutter'] || "";

  const flutterSegment = "Flutter";
  let isAssigned = false;

  if (parentDRSFlutterABTest == flutterSegment || teacherDRSFlutterABTest == flutterSegment) {
    isAssigned = true;
  }
  localStorage.setItem("isFlutterUser", isAssigned);
  return isAssigned;
}

export const hasTimeExceedInFreemiumNoBlocker = () => {
  const { student } = Store.getState();
  if(student && student.id) {
    const studentExistInCookie = getCookie(`NoBlocker_${student.id}`);
    const studentObj = studentExistInCookie && JSON.parse(studentExistInCookie);
    if(studentExistInCookie && studentObj && studentObj.startTime != 0 && fetchDiffInMinsBetweenTimestamps(studentObj.startTime, new Date().getTime()) >= FREEMIUM_NO_BLOCKER_TIME_IN_MINUTE) {
      return true;
    }
  }
  return false;
}

export const hasAccessToTeacherFreemiumNoBlocker = () => {
  return false;
  // const { abTests } = Store.getState();
  // let isAbTestValue = false;
  // if(abTests && abTests.teacher) {
  //   let abTestSegment = abTests.teacher['Teacher::FreemiumNoBlocker'];
  //   if(abTestSegment == 'FreemiumNoBlocker' && ((isFreemiumDRSAssigned() && !isMobileDevice()) || (hasGamification() && !isTabletDevice() && !isMobileDevice()))) {
  //     isAbTestValue = true;
  //     const { settings } = Store.getState();
  //     if(settings.via_teacher_student_center) {
  //       setCookieWithAge("freemiumNoBlockerViaTeacherStudentCenter", true)
  //     }
  //   }
  // }
  // return isAbTestValue;
}

export const isDRSWithCategoryExpansion = () => {
  const { abTests,settings } = Store.getState();
  const isAbTestValueParent = getABTestValue("Parent","DRSCategoryExpansion") === "Variant" ? true : false;
  const isAbTestValueTeacher = abTests && abTests.teacher && abTests.teacher["Teacher::DRSCategoryExpansion"] === "Variant" ? true : false;

  if(settings.is_classroom_student) {
    return isAbTestValueTeacher;
  }
  return isAbTestValueParent;
}

export const hasSBCertificateAccess = () => {
  const { wonSBCertificate, settings } = Store.getState();
  if(!isWebView() && settings?.is_classroom_student && (wonSBCertificate?.length > 0)) {
    return true;
  }
  return false;
}

export const isScrollTrackingAbTestAssigned = () => {
  const isAbTestValue = getABTestValue("Parent","ScrollTracking") === "ScrollTracked" ? true : false;
  if(isAbTestValue) {
    return true;
  }
  return false;
}

// Whether DRS dashboard creation required or not
export const isEligibleForDRSDashboard = () =>{
  return hasAccessToFreemium() || hasAccessToFlutterDRS();
}

export const hasHomeSchoolScreenVariant = () => {
  if(isFlutterSettingsAssigned()){
    return false;
  }
  if(isStudentWebsiteEnabled() && !(window.location.origin.includes('play'))){
    return false;
  }
  return true
}

export const hasSummerLearningWithoutDiscountVariant = () => {
  const { abTests } = Store.getState();
  if(abTests && abTests.teacher) {
    let abTestSegment = abTests.teacher['Teacher::SummerLearningWithoutDiscount'];
    if(abTestSegment == "Variant") {
      return true
    }
    else {
      return false
    }
  }
  return false
}


// condition to show Home School Popup on login via klass code
export const showHomeSchoolScreen = ({viaTeacherStudentCenter, loggedInGuardianType, isClassroomStudent, from}) => {
  return hasHomeSchoolScreenVariant() && !viaTeacherStudentCenter && (loggedInGuardianType === "teacher") && isClassroomStudent
}

// abtest for new plan page
export const hasPremiumLive = () => {
  const segment = getABTestValue("Parent", "Premium_live_plan");
    if(isMobileDevice() && !hasAccessToFlutterDRS()){
      return false;
    }
    if(isTabletDevice() && !(hasAccessToFlutterDRS() || hasAccessToFreemium())){
      return false
    }
   return  (segment === "Variant" || segment === "Add_On");
}

export const hasTeacherPremiumLive = () =>{
  /// for mela dashboard not showing t2 purchase page
  if(isMobileDevice() && !hasAccessToFlutterDRS()) {
    return false;
  }
  return getTeacherABTestValue("Teacher::Premium_live_plan") === "Variant";
}

/// This function tells whether to show or not T2 purchase page.
/// if grade is not provided in param selected student grade will consider on the basis of course
export const toShowT2PurchasePage = () => {
  if(!isAnyStudentClassroomLinked()){
    return true;
  }
  else{    
    return !isOldPlanTierAssigned();
  }
};

export const showActivityTextForT2Purchase = (studentId) => {
  if ((fetchHighestUserGrade(studentId) != PRE_K_GRADE) && toShowT2PurchasePage()) {
    return true;
  }
  return false;
};

export const isDynamicPositioningAssigned = () => {
  const { abTests, settings } = Store.getState();
  const isAbTestValueParent = getABTestValue("Parent", "DynamicPositioning") === "Variant" ? true : false;
  const isAbTestValueTeacher = abTests && abTests.teacher && abTests.teacher["Teacher::DynamicPositioning"] === "Variant" ? true : false;

  if (settings.is_classroom_student) {
    return isAbTestValueTeacher;
  }
  return isAbTestValueParent;
}

export const isNewCoqAssigned = () => {
  const isAbTestValue = getABTestValue("Parent","NewCOQs") === "Variant" ? true : false;
  if(isAbTestValue) {
    return true;
  }
  return false;
}

/// abtest to show pitch page before purchase page for ptl user
export const showPitchPageForRepeatedUsers = () => {
  if(localStorage.getItem('isPtlUser') == 'true'){
    return true;
  }
  else{
    return false;
  }
}

export const isPasswordlessloginUser = () => {
  return getTeacherABTestValue("Teacher::PasswordLessLogin") === "variant";
}

export const isRemoteLoginUser = () => {
  return getTeacherABTestValue("Teacher::RemoteLogin") === "variant";
}

export const isFlutterOnboardingAssigned = () => {
  const { settings } = Store.getState();
  if (settings.is_classroom_student) {
    return false;
  }
  const segmentName = getABTestValue("Parent","FlutterOnboarding");
  const isAbTestValue = (segmentName !== null && segmentName !== "Control") ? true : false; /// Will change ab test name upon creation
  if(isAbTestValue) {
    return true;
  }
  return false;
}

export const isDashboardCachingEnabled = () => {
  return getTeacherABTestValue("Teacher::DashboardCaching") === "Variant";
}

export const isB2BRepeatUser = () => {
  return getTeacherABTestValue("Teacher::RepeatUsersDiscount") === "Variant";
}

export const isFlutterTodos = () => {
  return getTeacherABTestValue("Teacher::FlutterTodos") === "Variant";
}

export const isBookLibraryP3Variant = () => {
  return (getTeacherABTestValue("Teacher::BookLibrary") === "Variant");
}

export const toShowStripePaymentElement = () => {
  const { settings } = Store.getState();
  if (settings.is_classroom_student) {
    return false;
  }
  const segment =
    getABTestValue('Parent', 'NewPaymentMethods');
  if (segment === 'variant_stripe') {
    return true;
  }

  /// to enable stripe payment element in discount flow
  if (segment === 'variant_paypal') {
    return true;
  }
  return false;
};

// [AI GENERATED CODE] - Updated to accept currentUser parameter instead of accessing from store
export const toShowStripePaymentElementWithPaypal = (currentUser) => {
  let tieredOfferings = {};
  try {
    tieredOfferings = JSON.parse(localStorage.getItem('tiered_offerings') || '{}');
  } catch (error) {
    // Malformed localStorage entry - treat as no trial available
    tieredOfferings = {};
  }

  const rawEnablePaypal = tieredOfferings?.settings?.enable_paypal;
  const enable_paypal = rawEnablePaypal === true || rawEnablePaypal === 'true';

  /// Check enable_paypal check first
  if (!enable_paypal) {
    return false;
  }

  const userCreatedDate = new Date(currentUser?.created_at);
  const updatedFeatureDate = new Date("2025-10-28")

  if(isBooksMonetizationVariant() && (userCreatedDate > updatedFeatureDate)){
    return true;
  }
  // Return true for any classroom linked Books monetization users
  if (isUSOrCACountry() && isAnyStudentClassroomLinked()) {
    return isBooksMonetizationVariant();
  }

  const segment =
    getABTestValue('Parent', 'NewPaymentMethods') === 'variant_paypal';
  if (segment) {
    return true;
  }
  return false;
};

export const isPL19VariantPremiumAssigned = () => {
  const isPtlUser = localStorage.getItem('isPtlUser') == 'true' || false;
  const segment = getABTestValue("Parent", "Premium_Live_$19") === "Variant_Premium";
  if(segment && !isPtlUser) {
    return true;
  }
    return false;
}

export const getAvatarGamificationSegment = () => {
  return getABTestValue("Parent", "Gamification_v1");
}

export const getAvatarGamificationSegmentTeacher = () => {
  let segment = getTeacherABTestValue("Teacher::Gamification_v1");
  return (!segment || segment === "Control") ? "Control" : "Variant";
}
export const getAvatarGamificationSegmentForPath = () => {
  if (isAvtarGamificationAssigned())
  {
    return "Variant"; // for all segments Variant needs to be returned, game side show changes based on this key only
  }
}

export const isAvtarGamificationAssigned = () => {
    const isClassroomStudent = JSON.parse(localStorage.getItem("is_classroom_student") || "false");

    const gamificationSegment = isClassroomStudent 
      ? getAvatarGamificationSegmentTeacher()
      : getAvatarGamificationSegment();
    
    return gamificationSegment && gamificationSegment !== "Control";
};

export const isFlutterPlayableLauncherAssigned = () => {
  let abtestValue = getABTestValue('Parent', 'FlutterPlayableLauncher');
  let abtestValueTeacher = getABTestValue('Teacher', 'FlutterPlayableLauncher');
  return  (abtestValue != null && abtestValue.toLowerCase() === 'variant') || 
  (abtestValueTeacher != null && abtestValueTeacher.toLowerCase() === 'variant');
}

export const isGameHeaderV1Assigned = () => {
  return getABTestValue("Parent","GameHeaderV1") === "Variant";
}

/// Create this fn. here to remove cyclic dependency
const unlimitedAccessOfferingsCount = (offerings) => {
  const UNLIMITED = 'unlimited';
  // here offerings is from tiered offering api
    // if offerings is null in params then fetch offerings value from local storage
    if(!offerings) {
        let settings = JSON.parse(localStorage.getItem('user_settings') || 'false') || {}; //it is from profile api
        offerings = settings?.current_tiered_offering?.offerings;
    }
    // Grouped 'lp' and 'downloadable_worksheets' into a single offering
    const groupedOfferings = {
        lp_and_worksheets: offerings?.lp == UNLIMITED || offerings?.downloadable_worksheets == UNLIMITED,
        live_class: offerings?.live_class == UNLIMITED,
        books: offerings?.books == UNLIMITED,
    };
    // Count the number of 'unlimited' offerings
    const unlimitedCount = Object.values(groupedOfferings).filter(value => value).length;
    return unlimitedCount;
}

export const isFlutterSettingsAssigned = () => {
  return JSON.parse(localStorage.getItem('is_flutter_settings_assigned'));
}

export const showCrossPlatformScreen = () => {
  const isAbTestValue = getABTestValue(null, "AB_PA:B2CP:NU:OB:AL:CrossPlatformAppDownload") === "Variant" ? true : false;
  return isAbTestValue;
}

// Utility functions and shared logic
const getCommonVariantSegmentLogic = () => {
  const tieredOfferingData = JSON.parse(localStorage.getItem('tiered_offerings') || '{}');
  const currentOfferings = tieredOfferingData?.current_tiered_offering || null;
  const parentGuardian = tieredOfferingData?.settings?.currentUser?.type === 'parent';

  return {
    currentOfferings,
    parentGuardian,
    hasAnyOneOfferingAccess: unlimitedAccessOfferingsCount(currentOfferings?.offerings) > 0
  };
};

const getBookMonetizationSegments = (validSegmentValues) => {
  const isSegmentEnabledForUser = (abValue) => validSegmentValues.includes(abValue);

  const parentSegmentEnabled = [
    getABTestValue("Parent", "OB_BookMonetisation_New"),
    getABTestValue("Parent", "OB_BookMonetisation_Old"),
  ].some(isSegmentEnabledForUser);

  const teacherSegmentEnabled = [
    getTeacherABTestValue("Teacher::OB_BookMonetisation_New"),
    getTeacherABTestValue("Teacher::OB_BookMonetisation_Old"),
  ].some(isSegmentEnabledForUser);

  const parentB2CSegmentEnabled = isSegmentEnabledForUser(getABTestValue("Parent", "OB_BookMonetisation"));

  return {
    parentSegmentEnabled,
    teacherSegmentEnabled,
    parentB2CSegmentEnabled
  };
};

// Exported functions
export const isProductStructureAssigned = () => {
  const { parentGuardian, hasAnyOneOfferingAccess } = getCommonVariantSegmentLogic();
  const segmentKeysForProductStructure = ["Control_Product_Structure", "Variant_Product_Structure"];
  const { parentSegmentEnabled, teacherSegmentEnabled, parentB2CSegmentEnabled } =
    getBookMonetizationSegments(segmentKeysForProductStructure);

  if (parentGuardian && hasAnyOneOfferingAccess) {
    return parentSegmentEnabled || parentB2CSegmentEnabled;
  }

  // There might be a delay in assigning book monetization abtest to parent but multi pack plan code gets assigned to that student
  // so to handle that edge case have added both user types check
  // apart from the above mentioned edge case all other cases would also be handled with it
  return parentSegmentEnabled || parentB2CSegmentEnabled || teacherSegmentEnabled;
};

export const isBooksMonetizationVariant = () => {
  // Check if books app user first
  const firstAppShortcode = JSON.parse(localStorage.getItem('user_student'))?.first_app_shortcode;
  const isBooksAppUser = isWebView() && (firstAppShortcode?.toLowerCase() === "smunbk");

  if (isBooksAppUser) {
    return true;
  }

  // Check variant assignment
  const { parentGuardian, hasAnyOneOfferingAccess } = getCommonVariantSegmentLogic();
  const segmentKeysForBooksMonetization = ["Variant", "Variant_Product_Structure"];
  const { parentSegmentEnabled, teacherSegmentEnabled, parentB2CSegmentEnabled } =
    getBookMonetizationSegments(segmentKeysForBooksMonetization);

  if (parentGuardian && hasAnyOneOfferingAccess) {
    return parentSegmentEnabled || parentB2CSegmentEnabled;
  }

  // There might be a delay in assigning book monetization abtest to parent but multi pack plan code gets assigned to that student
  // so to handle that edge case have added both user types check
  // apart from the above mentioned edge case all other cases would also be handled with it
  return parentSegmentEnabled || parentB2CSegmentEnabled || teacherSegmentEnabled;
};

export const isNewLPAssigned = () => {
  return getABTestValue('Parent', 'New_Learning_Path') === "Variant";
}

export const planVariantOneForMEBV2 = () => {
  const isAbTestValue = getABTestValue(null, "AB_PA:B2CP:NU:PF:AL_MEBv2") === "Variant1" ? true : false;
  return isAbTestValue;
}

export const planVariantTwoForMEBV2 = () => {
  const isAbTestValue = getABTestValue(null, "AB_PA:B2CP:NU:PF:AL_MEBv2") === "Variant2" ? true : false;
  return isAbTestValue;
}

export const showPremiumVariantForMEBV2 = () => {
  return planVariantOneForMEBV2() || planVariantTwoForMEBV2();
}


/// Checks whether StudentWebsite test assigned or not
export const isStudentWebsiteEnabled = () =>{
  const { abTests } =  Store.getState();
  const parentDRSFlutterABTest = getABTestValue('Parent','StudentWebsite') || "";
  const teacherDRSFlutterABTest = abTests && abTests?.teacher && abTests.teacher['Teacher::StudentWebsite'] || "";

  const segment = "Variant";
  let isAssigned = false;

  if ((parentDRSFlutterABTest == segment) || (teacherDRSFlutterABTest == segment)) {
    isAssigned = true;
  }
  return isAssigned;
}

// [AI GENERATED CODE] Winback-assigned users are excluded from FreemiumModels — returns null for
// them instead of the raw AB test value (Winback takes priority — see isWinbackAssigned).
export const getFreemiumModelsSegmentAssigned = () => {
  if (isWinbackAssigned()) { return null; }
  return getABTestValue(null, "AB_PA:B2CP:NU:FE:AL:FreemiumModels");
};

// [AI GENERATED CODE] Raw AB_PA:B2CP:NU:FE:AL:StudentDashboardExperiments variant, forced to
// "Control" for Winback-assigned users (Winback takes priority — see isWinbackAssigned).
const getStudentDashboardExperimentsVariant = () => {
  if (isWinbackAssigned()) { return "Control"; }
  return getABTestValue(null, "AB_PA:B2CP:NU:FE:AL:StudentDashboardExperiments");
};

// [AI GENERATED CODE] Returns the assigned segment for AB_PA:B2CP:NU:FE:AL:StudentDashboardExperiments,
// or null if the user is in Control or unassigned. Drives Permanent Nudge CTA text and color.
// FreemiumModels time-limit segments take priority: returns null when user is in both a time-limit and a free-trial segment.
export const getStudentDashboardExperimentsSegment = () => {
  const VALID_SEGMENTS = [
    "FreeTrialCTAonPN_mint",
    "StartFreeTrialCTAonPN_mint",
    "StartFreeTrialCTAonPN_mint_benefitscreen",
    "FreeTrialCTAonPN_orange",
    "FreeTrialCTAonPN_golden",
    "FreeTrialCTAonPN_gradient",
  ];
  const variant = getStudentDashboardExperimentsVariant();
  if (!variant || !VALID_SEGMENTS.includes(variant)) { return null; }

  // FreemiumModels time-limit segments take priority over StudentDashboard free-trial segments
  // when a user is assigned to both. Mirrors FREEMIUM_MODELS_TIME_LIMIT_SEGMENTS (Web repo
  // constants.rb) / getStudentDashboardExperimentsSegment's timeLimitSegments (flutter_app
  // user_ab_test.dart) exactly.
  const TIME_LIMIT_SEGMENTS = [
    "time_limit_10",
    "time_limit_15",
    "time_limit_20",
    "time_limit_25",
    "time_limit_30",
    "time_limit_10_direct",
    "time_limit_20_direct",
  ];
  const freemiumModelsSegment = getFreemiumModelsSegmentAssigned();
  if (TIME_LIMIT_SEGMENTS.includes(freemiumModelsSegment)) {
    return null;
  }

  return variant;
}

// [AI GENERATED CODE] Returns the Permanent Nudge CTA text for this AB test.
// "Start free trial" for StartFreeTrialCTAonPN_* segments; "Free trial" for all others.
// Returns null when not in the test.
export const getStudentDashboardExperimentsCtaText = () => {
  const segment = getStudentDashboardExperimentsSegment();
  if (!segment) { return null; }
  if (
    segment === "StartFreeTrialCTAonPN_mint" ||
    segment === "StartFreeTrialCTAonPN_mint_benefitscreen"
  ) {
    return "Start free trial";
  }
  return "Free trial";
}

// [AI GENERATED CODE] Returns the color variant for the Permanent Nudge CTA button.
// Possible values: "mint" | "orange" | "golden" | "gradient" | "default" | null (not in test).
export const getStudentDashboardExperimentsCtaVariant = () => {
  const segment = getStudentDashboardExperimentsSegment();
  if (!segment) { return null; }
  if (segment.includes("_mint")) { return "mint"; }
  if (segment.includes("_orange")) { return "orange"; }
  if (segment.includes("_golden")) { return "golden"; }
  if (segment.includes("_gradient")) { return "gradient"; }
  return "default";
}

// [AI GENERATED CODE] Returns true when the benefit screen should be shown before the purchase
// flow — only for the StartFreeTrialCTAonPN_mint_benefitscreen segment.
export const shouldShowBenefitScreenForStudentDashboard = () => {
  const hasAccessToBooks = hasFullAccessToProductType(OfferingType.books);
  const hasAccessToLP = hasFullAccessToProductType(OfferingType.lp);
  if(isWebView() || hasAccessToLP || hasAccessToBooks) {
    return false;
  }
  return getStudentDashboardExperimentsSegment() === "StartFreeTrialCTAonPN_mint_benefitscreen";
}

// [AI GENERATED CODE] Mirrors Flutter permanentNudgeCtaText():
const WINBACK_STUDENT_DASHBOARD_FEATURES_AB_TEST_NAME = "AB_PA:B2CP:OU:FE:AL:WinbackStudentDashboardFeatures";

// [AI GENERATED CODE] Returns true when the user is enrolled in a non-control segment of
// WINBACK_STUDENT_DASHBOARD_FEATURES_AB_TEST_NAME.
export const isWinbackAssigned = () => {
  const segment = getABTestValue(null, WINBACK_STUDENT_DASHBOARD_FEATURES_AB_TEST_NAME);
  if(segment){
    return true;
  };
  return false;
};

// [AI GENERATED CODE] The separate AB test the old Winback ZeroPS segments' behavior now lives
// under — mirrors PermanentNudgeCta::Constants::WINBACK_MODELS_AB_TEST_NAME (users_controller.rb)
// and AB_TEST_WINBACK_MODEL (ab_test_service_package.dart). Segments: Control_2PS, Variant_0PS.
const WINBACK_MODEL_AB_TEST_NAME = "AB_PA:B2CP:OU:FE:AL:WinbackModels";

// [AI GENERATED CODE] Returns the raw WINBACK_MODEL_AB_TEST_NAME segment ("Control_2PS" /
// "Variant_0PS"), or null if not assigned. Mirrors getWinbackModelSegment (user_ab_test.dart).
export const getWinbackModelSegment = () => {
  return getABTestValue(null, WINBACK_MODEL_AB_TEST_NAME) || null;
};

// [AI GENERATED CODE] BE contract for POST /web_api/common/student/v1/permanent_nudge_cta —
const PERMANENT_NUDGE_DISCOUNT_PLACEHOLDER = '<discount>';
// [AI GENERATED CODE] Real Winback segment names that carry discount framing — mirrors
const DISCOUNT_WINBACK_STUDENT_DASHBOARD_FEATURES_SEGMENTS = [
  'CTA_Renewdiscount',
  'CTA_Renewdiscount_RenewBanner',
];

// [AI GENERATED CODE] Mirrors _applyPermanentNudgeDiscountPlaceholder (flutter_app helper.dart):
const applyPermanentNudgeDiscountPlaceholder = (text, discount) => {
  if (!text || !text.includes(PERMANENT_NUDGE_DISCOUNT_PLACEHOLDER)) return text;
  if (!discount) return 'Renew now';
  return text.split(PERMANENT_NUDGE_DISCOUNT_PLACEHOLDER).join(discount);
};

// [AI GENERATED CODE] camelCase for trialExpired: mirrors StudentSubscriptionAccess.value
const computeSubscriptionState = () => {
  const settings = JSON.parse(localStorage.getItem('user_settings') || '{}') || {};
  const trialAvailable = settings.trialAvailable !== false && settings.trialAvailable !== 'false';
  const isPaidUser = hasFullAccessToProductType(OfferingType.lp) || hasFullAccessToProductType(OfferingType.books);
  const offeringCode = (JSON.parse(localStorage.getItem('current_tiered_offering') || '{}') || {}).offering_code || '';
  const subscriptionStatus = getSubscriptionAccessStatus();
  return { subscriptionStatus, trialAvailable };
};

// [AI GENERATED CODE] Calls the permanent_nudge_cta BE API directly and dispatches the raw
export const fetchAndCachePermanentNudgeCtaConfig = async (studentId) => {
  if (!studentId) return;
  try {
    const { subscriptionStatus, trialAvailable } = computeSubscriptionState();

    const response = await FetchPermanentNudgeCtaConfig({
      student_id: studentId,
      ab_tests: getAllAbTests(),
      user_params: {
        subscription_status: subscriptionStatus,
        is_trial_available: trialAvailable,
        device: getDeviceType(),
        country: getUserCountryCode(),
        preferred_language: getUserPreferredLanguage(),
        offerings: getCurrentOfferings(),
      },
    }, true);

    if (response) {
      ParentStore.dispatch({ type: 'SET_PERMANENT_NUDGE_CTA_CONFIG', payload: response });
    }
  } catch (err) {
    // Network/parse failure — leave the store as-is, getPermanentNudgeCtaText falls back below.
  }
};

// [AI GENERATED CODE] True when a non-Control Winback segment is assigned and the user is
export const isNonControlWinbackExpired = () => {
  const winbackStudentDashboardFeaturesSegment = getABTestValue(null, WINBACK_STUDENT_DASHBOARD_FEATURES_AB_TEST_NAME);
  const status = computeSubscriptionState().subscriptionStatus;
  return !!winbackStudentDashboardFeaturesSegment && winbackStudentDashboardFeaturesSegment !== 'Control' && (status === 'expired' || status === 'trialExpired');
};

export const getPermanentNudgeCtaText = (defaultText, useDiscountFramingForRenew = false, discount = null, touchpoint = null) => {
  // [AI GENERATED CODE] BE-resolved text takes priority when this call site identifies its
  if (touchpoint) {
    const config = ParentStore.getState().permanentNudgeCtaConfig;
    const touchpointResult = config?.ui_def?.find((t) => t.screen_code === touchpoint);
    const ctaText = touchpointResult?.cta_text;
    if (ctaText) {
      return applyPermanentNudgeDiscountPlaceholder(ctaText, discount);
    }
  }

  const winbackStudentDashboardFeaturesSegment = getABTestValue(null, WINBACK_STUDENT_DASHBOARD_FEATURES_AB_TEST_NAME);
  // [AI GENERATED CODE] Renew/discount framing applies to expired and trialExpired alike
  if (isNonControlWinbackExpired()) {
    if (DISCOUNT_WINBACK_STUDENT_DASHBOARD_FEATURES_SEGMENTS.includes(winbackStudentDashboardFeaturesSegment) && useDiscountFramingForRenew && discount) {
      return `Renew at ${discount}% off`;
    }
    return "Renew now";
  }

  if(isExpiredUser()) { // For expired users
    return defaultText;
  }
  const segment = getStudentDashboardExperimentsSegment();
  if (segment) {
    const isSmallMobile = window.innerWidth < 350;
    if (isSmallMobile) return 'Free trial';
    return getStudentDashboardExperimentsCtaText() ?? defaultText;
  }
  return defaultText;
};

// [AI GENERATED CODE] Returns the BE-resolved `cta_icon_required`
export const getPermanentNudgeCtaIconRequired = (touchpoint = null) => {
  if (!touchpoint) return null;
  const config = ParentStore.getState().permanentNudgeCtaConfig;
  const touchpointResult = config?.ui_def?.find((t) => t.screen_code === touchpoint);
  if (!touchpointResult) return null;
  return !!touchpointResult.cta_icon_required;
};

// [AI GENERATED CODE] Returns whether UnlockContentBanner should be shown
export const getPermanentNudgeShowBanner = (touchpoint = null) => {
  if (touchpoint) {
    const config = ParentStore.getState().permanentNudgeCtaConfig;
    const touchpointResult = config?.ui_def?.find((t) => t.screen_code === touchpoint);
    if (touchpointResult && typeof touchpointResult.show_banner === 'boolean') {
      return touchpointResult.show_banner;
    }
  }

  if (isNonControlWinbackExpired()) {
    return true;
  }

  return getFreemiumModelsSegmentAssigned()?.toLowerCase() !== 'control';
};

// [AI GENERATED CODE] UnlockContentBanner-specific visibility gate
export const showPurchaseBanner = (touchpoint = null) => {
  const { settings } = Store.getState();
  if ((settings && settings.is_classroom_student) || JSON.parse(localStorage.getItem("is_classroom_student"))) {
    return false;
  }
  const hasFullAccess = hasFullAccessToProductType(OfferingType.lp) && hasFullAccessToProductType(OfferingType.books);
  if (hasFullAccess) {
    return false;
  }
  if (isWebView() && !showNewUnlockBannerOnApp()) {
    return false;
  }
  return getPermanentNudgeShowBanner(touchpoint);
};

// [AI GENERATED CODE] Mirrors permanentNudgeBannerText (flutter_app helper.dart)
const PERMANENT_NUDGE_BANNER_NAME_PLACEHOLDER = '<student_name>';

// [AI GENERATED CODE] The plain banner text a non-Winback-assigned dashboard user sees
export const DEFAULT_PERMANENT_NUDGE_BANNER_TEXT = 'Get unlimited access across subjects and grades.';

// [AI GENERATED CODE] The plain banner text for every touchpoint except dashboard
const DEFAULT_WINBACK_MODEL_BANNER_TEXT = 'Get unlimited access to Pre-K–Grade 5 content for up to 3 children.';

// [AI GENERATED CODE] Returns UnlockContentBanner's centered message.
export const getPermanentNudgeBannerText = (touchpoint = null) => {
  if (touchpoint) {
    const config = ParentStore.getState().permanentNudgeCtaConfig;
    const touchpointResult = config?.ui_def?.find((t) => t.screen_code === touchpoint);
    if (touchpointResult?.banner_text) {
      const firstName = localStorage.getItem('first_name') || '';
      return touchpointResult.banner_text.split(PERMANENT_NUDGE_BANNER_NAME_PLACEHOLDER).join(firstName);
    }
  }

  if (!touchpoint || touchpoint === 'dashboard') {
    return dashboardBannerTextFallback();
  }
  return defaultBannerTextFallback();
};

// [AI GENERATED CODE] dashboard's banner_text fallback — unchanged, still Winback-driven.
const dashboardBannerTextFallback = () => {
  const firstName = localStorage.getItem('first_name') || '';
  if (!isWinbackAssigned()) {
    return DEFAULT_PERMANENT_NUDGE_BANNER_TEXT;
  }
  return `${firstName} is down to 2 learning activities a day. Renew to unlock limitless learning!`;
};

// [AI GENERATED CODE] banner_text fallback for every touchpoint except dashboard —
// WINBACK_MODEL_AB_TEST_NAME-driven, Winback no longer consulted.
const defaultBannerTextFallback = () => {
  const firstName = localStorage.getItem('first_name') || '';
  const winbackModelSegment = getWinbackModelSegment();
  if (winbackModelSegment === 'Control_2PS') {
    return `${firstName} is down to 2 learning activities a day. Renew to unlock unlimited learning`;
  }
  if (winbackModelSegment === 'Variant_0PS') {
    return `${firstName}'s learning is paused. Renew to unlock unlimited learning`;
  }
  return DEFAULT_WINBACK_MODEL_BANNER_TEXT;
};

// [AI GENERATED CODE] Reads the permanent_nudge_cta resolution the native app bridges into
export const getAppDeviceConfigPermanentNudgeUiDef = () => {
  if (!isWebView()) return null;
  try {
    const appDeviceConfig = JSON.parse(localStorage.getItem('appDeviceConfig'));
    const uiDef = appDeviceConfig?.ui_def;
    const firstName = localStorage.getItem('first_name') || '';
    return {
      ctaText: applyPermanentNudgeDiscountPlaceholder(uiDef.cta_text, appDeviceConfig.win_back_yearly_discount),
      showIcon: !!uiDef.cta_icon_required,
      bannerText: uiDef.banner_text
        ? uiDef.banner_text.split(PERMANENT_NUDGE_BANNER_NAME_PLACEHOLDER).join(firstName)
        : null,
    };
  } catch (error) {
    return null;
  }
};

export const showNewUnlockBanner = () => {

  const { settings } = Store.getState();
  if((settings && settings.is_classroom_student) || JSON.parse(localStorage.getItem("is_classroom_student"))) {
    return false;
  }

  const hasFullAccess = hasFullAccessToProductType(OfferingType.lp) && hasFullAccessToProductType(OfferingType.books);
  
  if(hasFullAccess) {
    return false;
  }
  if(isWebView()){
    if(!showNewUnlockBannerOnApp()){
      return false;
    }
  }
  if(isWinbackAssigned()){
    return true;
  }
  if(getFreemiumModelsSegmentAssigned()?.toLowerCase() === 'control'){
    return false;
  }
  return true;
}

export const isNewLearningPathAbTestAssigned = () => {
    const newLearningPathSegment = getABTestValue("Parent", "New_Learning_Path");
    return newLearningPathSegment && newLearningPathSegment !== "Control";
};

// [AI GENERATED CODE] Returns true when the user's variant should lock grades on report
export const lockGradesOnReport = () => {
  const studentDashboardExperimentsVariant = getStudentDashboardExperimentsVariant();

  return [
    "AddChild_GradeLock_NoContentDiscovery",
    "AddChild_GradeLock_WithContentDiscovery",
  ].includes(studentDashboardExperimentsVariant);
}

export const isMagicalDashboardV1Assigned = () => {
  const variant = getABTestValue(null, "AB_PA:B2CP:NU:magical_dashboard_v1");
  if (!variant) { return false; }
  return variant === "Variant";
};

// [AI GENERATED CODE] Web equivalent of Flutter's isCancellationRecoveryAssigned().
// Returns true when the user is enrolled in a non-control segment of AB:B2C:OU:FE:AL:Cancellation_Recovery.
export const isCancellationRecoveryAssigned = () => {
  const segment = getABTestValue(null, 'AB:B2C:OU:FE:AL:Cancellation_Recovery');
  if (!segment) return false;
  return segment !== 'control';
};

export const shouldShowWinbackPitchScreen = () => {
  const hasAccessToBooks = hasFullAccessToProductType(OfferingType.books);
  const hasAccessToLP = hasFullAccessToProductType(OfferingType.lp);
  if(isWebView() || hasAccessToLP || hasAccessToBooks) {
    return false;
  }
  const winbackModelSegment = getWinbackModelSegment();
  if (winbackModelSegment === 'Variant_0PS') {
    return true;
  }
  return false;
};

// [AI GENERATED CODE]
// AB test constants for Invite Surfaces GP LO Pitch (ported from ab_test_service_package.dart's showGuestPassChanges)
const AB_TEST_TEACHER_INVITE_SURFACES_GP_LO_PITCH = "Teacher::InviteSurfaces_GP_LO_Pitch";

// Returns the assigned AB test segment for Invite Surfaces GP LO Pitch, teacher segment preferred over parent.
export const getInviteSurfacesGPLOPitchSegment = () => {
  const { abTests } = Store.getState();
  const teacherSegment = abTests && abTests.teacher && abTests.teacher[AB_TEST_TEACHER_INVITE_SURFACES_GP_LO_PITCH];
  const parentSegment =  getABTestValue('Parent', 'InviteSurfaces_GP_LO_Pitch');;
  return teacherSegment || parentSegment || null;
};

// [AI GENERATED CODE]
// True when assigned a non-control Invite Surfaces GP LO Pitch segment and the student has no paid access.
export const toShowGuestPassChanges = () => {
  const segment = getInviteSurfacesGPLOPitchSegment();
  const isSegmentAssigned = (segment && (segment.toLowerCase() == 'variant-a' || segment.toLowerCase() == 'variant-c'));
  return isSegmentAssigned;
};